"use client";
import React, { useState, useEffect } from 'react';
import { useEditMode } from './EditModeProvider';
import EditableImage from './EditableImage';

const IphoneCarousel = ({ activeIndex = 0 }) => {
  const { isEditMode, getContent } = useEditMode();

  const defaultImages = [
    '/images/screen1.jpg',
    '/images/screen2.jpg',
    '/images/screen3.jpg'
  ];

  const currentImages = [
    getContent('iphone_screen_1', defaultImages[0]),
    getContent('iphone_screen_2', defaultImages[1]),
    getContent('iphone_screen_3', defaultImages[2]),
  ];

  const [imageErrors, setImageErrors] = useState({});

  useEffect(() => {
    setImageErrors({});
  }, [currentImages[0], currentImages[1], currentImages[2]]);

  const handleError = (index) => {
    setImageErrors(prev => ({ ...prev, [index]: true }));
  };

  return (
    <div className="relative w-[275px] h-[560px] sm:w-[320px] sm:h-[650px] bg-black rounded-[46px] sm:rounded-[55px] shadow-2xl border-[10px] sm:border-[12px] border-black overflow-hidden flex-shrink-0 ring-1 ring-gray-800">
      {/* Dynamic Island (iPhone 16 Pro style) */}
      <div className="absolute top-2 left-1/2 -translate-x-1/2 h-7 bg-black rounded-full w-32 z-20 flex items-center justify-between px-3">
         <div className="w-2.5 h-2.5 rounded-full bg-[#111] shadow-inner"></div>
         <div className="w-2.5 h-2.5 rounded-full bg-blue-900/30"></div>
      </div>
      
      {/* Screen */}
      <div className="relative w-full h-full bg-white dark:bg-gray-900 overflow-hidden rounded-[36px] sm:rounded-[43px]">
        {defaultImages.map((defaultSrc, index) => {
          const hasError = imageErrors[index];
          const contentKey = `iphone_screen_${index + 1}`;
          const isActive = index === activeIndex;

          return (
            <div
              key={index}
              className={`absolute inset-0 w-full h-full transition-opacity duration-1000 flex items-center justify-center bg-gray-100 dark:bg-gray-800 overflow-hidden ${
                isActive ? 'opacity-100 z-10' : 'opacity-0 z-0'
              }`}
            >
              {(!hasError || isEditMode) ? (
                <EditableImage
                  contentKey={contentKey}
                  defaultSrc={defaultSrc}
                  alt={`Screen ${index + 1}`}
                  className="w-full h-full object-cover"
                  style={{
                    width: '100%', 
                    height: '100%',
                    transform: isActive ? 'scale(1.08)' : 'scale(1)',
                    transition: 'transform 5000ms cubic-bezier(0.16, 1, 0.3, 1)'
                  }}
                  onError={() => handleError(index)}
                />
              ) : null}
              
              {/* Fallback, если картинка не найдена и не в режиме редактирования */}
              {(hasError && !isEditMode) && (
                <div className="flex flex-col items-center justify-center text-gray-400 text-center p-4">
                  <span className="font-medium">Изображение {index + 1}</span>
                  <span className="text-xs text-gray-500 mt-2">Загрузите файл по пути:<br/>{defaultSrc}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IphoneCarousel;